import {Vector} from "./vector.js";

export default class Camera {
	constructor(space) {
		this.space = space;

		// pos of the center of the screen
		this.pos = new Vector();
		// Latest screen size
		this.screenSize = new Vector(1, 1);
	}

	// pos is the pos of the player for now
	setPos(pos) {
		this.pos.copyFrom(pos);

		// Overwrite pos in brainrot mode
		let game = this.space.game;
		if (game.debugger !== undefined && game.debugger.brainrotMode) {
			let cossetteReport = this.space.requestTacticalReport(
				t => t.identity === "COSSETTE", "CAMERA"
			);
			if (cossetteReport.length !== 1) return;
			// Get the most up to date pos to make the camera more steady
			this.pos.copyFrom(cossetteReport[0].thing.pos);
		}
	}

	setScreenSize(screenSize) {
		this.screenSize.copyFrom(screenSize);
	}

	getPos() {
		return new Vector(this.pos);
	}

	posToPosition(pos, pixelsPerFlare) {
		return Vector.diff(pos, this.pos).scale(pixelsPerFlare)
			.add(Vector.scale(this.screenSize, 0.5));
	}
}
